import { ROLE_CONFIG } from "@/features/members/config";
import { ProjectRoleType } from "@/features/projects/types";

interface Props {
  role: ProjectRoleType;
}

export function RoleBadge({ role }: Props) {
  const config = ROLE_CONFIG[role];
  const Icon = config.icon;

  return (
    <div className={`flex items-center gap-1.5 text-xs font-semibold ${config.className}`}>
      <Icon className="size-3.5 shrink-0" />
      {role}
    </div>
  );
}
